// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Hero__Wrapper_1JhP8","Head":"Hero__Head_1vaoo","Title":"Hero__Title_ON-6Y","Link":"Hero__Link_2qI3t","Factoids":"Hero__Factoids_cAmh6"};